import { message } from "antd";
import { useState } from "react";
import { ModalPortal } from "../../../../../common/components/modalPortal/modalPortal";
import { RecruiterGoals } from "../../../../../redux/models/recruiterGoals";
import { DeleteGoalsModal } from "./deleteGoalsModal";
import { DeleteIconButton } from "../../../../../common/components/iconButton/deleteIconButton";

export const DeleteGoalsButton = ({ goal, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const onDelete = (closeModal) => async () => {
    setLoading(true);

    try {
      await RecruiterGoals.delete(goal.id, false);
      closeModal();
      onSuccess?.(goal);
      message.success("Goals deleted successfully");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ModalPortal
      renderTrigger={(triggerProps) => (
        <DeleteIconButton {...triggerProps} />
      )}
    >
      {({ open, closeModal }) => (
        <DeleteGoalsModal
          goal={goal}
          open={open}
          loading={loading}
          closeModal={closeModal}
          onDelete={onDelete(closeModal)}
        />
      )}
    </ModalPortal>
  );
};
